export const defaultSettings = {
  imageUrl: '',
  altText: '',
  fullWidth: false,
  align: 'center',
  imageLink: '',
  width: '',
  // Intrinsic image dimensions, captured when the image is added/changed, used
  // to reserve the rendered box so a blocked image doesn't collapse (FE-1128).
  naturalWidth: null,
  naturalHeight: null,
};
